import { Text, ToastAlertTypes, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';

import { ModalSelectedItems } from '../../store/ProducManagement/atom';

import { PlatformList } from './components/ProductsManagementBlockModal/constants';

export enum ProductType {
  FUNDS = 1,
  FIXED_INCOME = 4,
}

export const ProductsTabs = [
  { tabIndex: 0, title: 'Fundos de investimento', productType: ProductType.FUNDS },
  { tabIndex: 1, title: 'Renda Fixa', productType: ProductType.FIXED_INCOME },
];

export const defaultErrorMessageRequestItem: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao realizar a solicitação.',
];

export const defaultSuccessDeleteMessageRequestItem: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'Bloqueio removido com sucesso!',
];

export const DeleteBatchBlockModelContent = ({ itemsAmount }: { itemsAmount: number }) => (
  <VStack alignItems="center" space={Spacing['stack.xxxs']} my={Spacing['stack.xxxs']}>
    <Text
      variant="semibold"
      color={Color['brand.primary.darkest']}
      fontSize={Typography['fontsize.lg']}>
      Remover bloqueio em lote?
    </Text>
    <VStack alignItems="center">
      <Text
        color={Color['brand.primary.darkest']}
        variant="regular"
        fontSize={Typography['fontsize.md']}>
        Serão removidos os {itemsAmount} bloqueios dos itens selecionados.
      </Text>
      <Text
        color={Color['brand.primary.darkest']}
        variant="regular"
        fontSize={Typography['fontsize.md']}>
        Confirma a remoção em lote?
      </Text>
    </VStack>
  </VStack>
);

export const CreateBatchBlockModelContent = (modalSelectedItems: ModalSelectedItems) => {
  return (
    <VStack
      w="full"
      space={Spacing['stack.xxxs']}
      justifyContent="center"
      alignItems="center"
      px={Spacing['inline.xxs']}
      my={Spacing['stack.xxxs']}>
      <Text
        variant="semibold"
        color={Color['brand.primary.darkest']}
        fontSize={Typography['fontsize.lg']}>
        Confirmação de ação em lote
      </Text>
      <HStack flexWrap="wrap" justifyContent="center" alignItems="center" my="stack.nano">
        <Text
          variant="regular"
          color={Color['brand.primary.darkest']}
          fontSize={Typography['fontsize.md']}>
          Confirma a ação em lote de{' '}
        </Text>
        <Text
          variant="semibold"
          color={Color['brand.primary.main']}
          fontSize={Typography['fontsize.md']}>
          BLOQUEAR
        </Text>
        <Text
          variant="regular"
          color={Color['brand.primary.darkest']}
          fontSize={Typography['fontsize.md']}>
          {' '}
          dos itens selecionados para o{' '}
        </Text>
        <Text
          variant="semibold"
          color={Color['brand.primary.main']}
          fontSize={Typography['fontsize.md']}>
          {modalSelectedItems.isClientOrAdvisor === 'client' && 'CLIENTE'}
          {modalSelectedItems.isClientOrAdvisor === 'advisor' && 'ASSESSOR'}
          {!modalSelectedItems.isClientOrAdvisor && 'PARCEIRO'}
        </Text>
        <Text
          variant="regular"
          color={Color['brand.primary.darkest']}
          fontSize={Typography['fontsize.md']}>
          {' '}
          na plataforma{' '}
        </Text>
        <Text
          variant="semibold"
          color={Color['brand.primary.main']}
          fontSize={Typography['fontsize.md']}>
          {PlatformList.find(
            (item) => Number(item.value) === modalSelectedItems.platformId
          )?.label.toUpperCase()}
        </Text>
        <Text
          variant="semibold"
          color={Color['brand.primary.darkest']}
          fontSize={Typography['fontsize.md']}>
          {' '}
          ?
        </Text>
      </HStack>

      {modalSelectedItems.isClientOrAdvisor && (
        <HStack justifyContent="flex-start" alignItems="center" space={Spacing['stack.quarck']}>
          <Text
            variant="semibold"
            color={Color['brand.primary.darkest']}
            fontSize={Typography['fontsize.md']}>
            {modalSelectedItems.isClientOrAdvisor === 'client' ? 'CLIENTE' : 'ASSESSOR'}:
          </Text>
          <Text
            color={Color['brand.primary.darkest']}
            variant="regular"
            fontSize={Typography['fontsize.md']}>
            {modalSelectedItems.clientOrAdvisorNameId?.name.toUpperCase()}
          </Text>
        </HStack>
      )}
    </VStack>
  );
};
